// removed by extract-text-webpack-plugin
module.exports = {"amount-refund":"app-components-receipt-refunds-AmountToRefund-__AmountToRefund___Iqq5B","amount-refund-label":"app-components-receipt-refunds-AmountToRefund-__AmountToRefund___X-VP8","amount-refund-input":"app-components-receipt-refunds-AmountToRefund-__AmountToRefund___ZQhPM"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/refunds/AmountToRefund/AmountToRefund.css
// module id = 2239
// module chunks = 0